import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HIRE_ROUTES } from "plg/routes";
import { trackPlg } from "plg/analytics/events";

/** Navigation state that says where a link was clicked: navigate(to, { state: plgEntry("home") }). */
export const plgEntry = (entry: string, state: Record<string, unknown> = {}) => ({ ...state, plgEntry: entry });

/**
 * talent_network_entered, once per navigation, from the entry the link set ("direct" when none did: a typed URL,
 * a bookmark, Back). Mounted once, in the PLG shell.
 */
export default function usePlgEntryTracking(): void {
  const { pathname, state, key } = useLocation();
  useEffect(() => {
    const s = (state || {}) as { plgEntry?: unknown };
    const entry_point = typeof s.plgEntry === "string" ? s.plgEntry : "direct";
    if (pathname === HIRE_ROUTES.talentNetwork) trackPlg("talent_network_entered", { entry_point });
    // One event per navigation: `key` changes on each one, a re-render alone does not.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
